import { createServerFn } from "@tanstack/solid-start";
import { z } from "zod";
import { withSentrySpan } from "~/lib/sentry-span";
import { authFunctionMiddleware } from "~/server/middleware/auth";

export const GetBusinessPageDataInputSchema = z.object({
  businessId: z.string().trim().min(1),
});

/**
 * Aggregate server function for the business settings page.
 *
 * Fetches business detail in a single HTTP round trip
 * on client-side navigation.
 */
export const getBusinessPageData = createServerFn({ method: "GET" })
  .middleware([authFunctionMiddleware])
  .validator((i: unknown) => GetBusinessPageDataInputSchema.parse(i))
  .handler(async ({ context, data }) => {
    return withSentrySpan("business.pageData", async () => {
      const { getBusinessDetailForUser } =
        await import("../business/business.server");

      const businessDetail = await getBusinessDetailForUser(
        context.user.id,
        data.businessId,
      );

      return { businessDetail } as const;
    });
  });
